<template>
  <div class="cydt flex">
    <div class="chinamap_box flex_1">
      <chinaMap
        :showVisualMap="false"
        :mapProvince="mapProvince"
        v-if="mapProvince.length > 0"
      />
    </div>
    <div class="index_statistic my_card flex flex_col">
      <div class="show_data flex jc_sb">
        <div class="data" v-for="(item, index) in pieData" :key="index">
          <div class="counts">
            <span class="count" :style="{ color: item.color }">
              {{ item.count }}
            </span>
            <span class="unit">{{ item.unit }}</span>
          </div>
          <div class="label">{{ item.label }}</div>
        </div>
      </div>
      <div class="chart_box flex_1">
        <ringVue
          :ringData="ringData"
          :innerRingList="innerRingList"
          v-if="
            ringData?.list?.every((i) => i.value != 0) &&
            innerRingList.length > 0
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import chinaMap from "@/components/map/map.vue";
import ringVue from "../com/ring.vue";
import { getCitysCompanyCounts } from "@/utils/commonMethods";
export default {
  name: "WorkspaceJsonCydt",
  components: { chinaMap, ringVue },
  props: {
    pieData: {
      type: Array,
      default() {
        return [
          /* { label: "医药企业", count: 10, unit: "家", color: "#409EFF" },
          { label: "高端人才", count: 11, unit: "人", color: "#67C23A" },
          { label: "科技成果", count: 12, unit: "个", color: "#E6A23C" }, */
        ];
      },
    },
  },
  data() {
    return {
      dtList: [],
      innerRingList: [],
    };
  },
  computed: {
    mapProvince() {
      return (
        this.dtList.map((item) => {
          return {
            name: item.name?.replace("市", "")?.replace("省", "") || "",
            value: item.count,
            key: item.key,
          };
        }) || []
      );
    },
    ringData() {
      let list = [];
      let color = [];
      this.pieData.map((item) => {
        list.push({
          name: item.label,
          value: item.count,
        });
        if (item.children?.length > 0) {
          this.innerRingList = item.children;
        }
        color.push(item.color);
      });
      color.push("#669999", "#ff5050", "#33cccc");
      // debugger;
      return {
        list,
        color,
      };
    },
  },
  async mounted() {
    this.dtList = await getCitysCompanyCounts();
  },

  methods: {},
};
</script>
<style lang="less" scoped>
.cydt {
  height: 400px;
  padding-right: 130px;
  .chinamap_box {
    height: 100%;
  }
  .index_statistic {
    width: 393px;
    height: 370px;
    padding: 20px;
    margin-top: 20px;
    .show_data {
      border-bottom: 1px dashed #efeef2;
      padding-bottom: 20px;
      .data {
        text-align: center;
        .counts {
          .count {
            font-weight: bold;
            font-size: 20px;
          }
          .unit {
            font-size: 12px;
          }
        }
        .label {
          font-size: 16px;
          color: #1d4a77;
          padding-top: 4px;
        }
      }
    }
  }
}
</style>